import * as actionTypes from "../actionTypes";
import axios from "../../middleware/axios-api";
import {
  formatBase64Image,
  getErrors,
  getResData,
} from "../../shared/utility";
import { USER_TYPE } from "../../constants/constants";

// getProfile
export const getProfileStart = () => {
  return {
    type: actionTypes.GET_USER_PROFILE_START,
    profile: null
  };
};

export const getProfileSuccess = (profile: any) => {
  // currently we are not getting the profile type for providers in api response
  if(!profile?.type) profile = {...profile, type: USER_TYPE.PROVIDER};

  return {
    type: actionTypes.GET_USER_PROFILE_SUCCESS,
    profile,
  };
};

export const getProfileFailed = (error: any) => {
  return {
    type: actionTypes.GET_USER_PROFILE_FAIL,
    error,
    profile: null,
  };
};

export const getProfile = () => {
  return async (dispatch: any) => {
    const userType = localStorage.getItem("m-market-user-type");
    const isProvider = (userType === USER_TYPE.PROVIDER)  ? true : false;

    dispatch(getProfileStart());

    if (localStorage.getItem("m-market-user-token")) {
      return axios
        .get(isProvider ? `/provider/profile` : `/user/profile`)
        .then((response) => {
          if (!response) throw new Error("No Response");
          if (response.data.errorCode === 129) {
            const data = {
              subscribed: false,
              message: "No Subscription",
            };
            return dispatch(getProfileSuccess(data));
          } else {
            const data = getResData(response.data);
            if (!data.success) throw new Error(getErrors(data));
            return dispatch(getProfileSuccess(data.data));
          }
        })
        .catch((err) => dispatch(getProfileFailed(getErrors(err))));
    } else {
      dispatch(
        getProfileFailed(getErrors("Something went wrong. Please try later"))
      );
    }
  };
};

// getProfileImage
export const getProfileImageStart = () => {
  return {
    type: actionTypes.GET_PROFILE_IMAGE_START,
    profileImage: null
  };
};

export const getProfileImageSuccess = (profileImage: any) => {
  return {
    type: actionTypes.GET_PROFILE_IMAGE_SUCCESS,
    profileImage,
  };
};

export const getProfileImageFailed = (error: any) => {
  return {
    type: actionTypes.GET_PROFILE_IMAGE_FAIL,
    error,
  };
};

export const getProfileImage = (isProvider: boolean = false) => {
  return (dispatch: any) => {
    dispatch(getProfileImageStart());

    return axios
      .get(isProvider ? `/provider/profile/picture/load` : `/user/profile/picture/load`)
      .then((response) => {
        if (!response) throw new Error("No Response");
        
        const data = formatBase64Image(response.data.data);   
    
        return dispatch(getProfileImageSuccess(data));
      })
      .catch((err) => dispatch(getProfileImageFailed(getErrors(err))));
  };
};

// Upload Profile Image
export const uploadProfileImageStart = () => {
  return {
    type: actionTypes.UPLOAD_PROFILE_IMAGE_START,
  };
};

export const uploadProfileImageSuccess = (uploadProfileImageRes: any) => {
  return {
    type: actionTypes.UPLOAD_PROFILE_IMAGE_SUCCESS,
    uploadProfileImageRes,
  };
};

export const uploadProfileImageFailed = (error: any) => {
  return {
    type: actionTypes.UPLOAD_PROFILE_IMAGE_FAIL,
    error,
  };
};

export const uploadProfileImage = (data: any, isProvider: boolean = false,) => {
  return async (dispatch: any) => {
    dispatch(uploadProfileImageStart());

    return axios
      .post(isProvider ? `/provider/profile/picture/upload` : `/user/profile/picture/upload`, data, {
        headers: { "Content-Type": "application/json" },
      })
      .then(async (response) => {
        if (!response) throw new Error("No Response");

        const data = getResData(response.data);

        if (!data.success) throw new Error(getErrors(data));

        await dispatch(uploadProfileImageSuccess(data.data));

        return await dispatch(getProfileImage(isProvider));
      })
      .catch((err) => dispatch(uploadProfileImageFailed(getErrors(err))));
  };
};

const countForHeaderStart = () => {
  return {
    type: actionTypes.HEADER_COUNT_START,
  }
}

const countForHeaderSuccess = (countData: any) => {
  return {
    type: actionTypes.HEADER_COUNT_SUCCESS,
    countData,
  }
}

const countForHeaderFailed = (error: any) => {
  return {
    type: actionTypes.HEADER_COUNT_FAIL,
    error
  }
}

export const getCountForHeader = () => {
  return (dispatch: any) => {
    
    dispatch(countForHeaderStart())
    return axios.get('/user/items/count')
    .then((response) => {
      if(!response) throw new Error ("No Response");

      const data = getResData(response.data)

      if(!data.success) throw new Error (getErrors(data));

      dispatch(countForHeaderSuccess(data.data))
    })
    .catch(err => dispatch(countForHeaderFailed(getErrors(err))))
  }
}

const updateProfileStart = () => {
  return {
    type: actionTypes.UPDATE_PROFILE_DATA_START
  }
}

const updateProfileSuccess = (profileData: any, updatedProfile: any) => {
  return {
    type: actionTypes.UPDATE_PROFILE_DATA_SUCCESS, 
    profileData,
    updatedProfile,
  }
}

const updateProfileFailed = (error: any) => {
  return {
    type: actionTypes.UPDATE_PROFILE_DATA_FAIL,
    error
  }
}

export const updateProfileData = (profile: any, isProvider: boolean = false,) => {
  return (dispatch: any) => {
    
    dispatch(updateProfileStart())
    return axios.post(isProvider ? '/provider/profile/update' : '/user/profile/save', profile)
    .then((response) => {
      if(!response) throw new Error ("No Response");

      const data = getResData(response.data)

      if(!data.success) throw new Error (getErrors(data));

      return dispatch(updateProfileSuccess(data,profile))
    })
    .catch(err => dispatch(updateProfileFailed(getErrors(err))))
  }
}

// switch user type
export const switchUserTypeStart = () => {
  return {
    type: actionTypes.SWITCH_USER_TYPE_START,
  };
};

export const switchUserTypeSuccess = (profileType: any) => {
  return {
    type: actionTypes.SWITCH_USER_TYPE_SUCCESS,
    profileType,
  };
};

export const switchUserTypeFailed = (error: any) => {
  return {
    type: actionTypes.SWITCH_USER_TYPE_FAIL,
    error,
  };
};

export const switchUserType = (data: any) => {
  return async (dispatch: any) => {
    dispatch(switchUserTypeStart());

    if (localStorage.getItem("m-market-user-token")) {
      return axios
        .post(`/user/profile/switch`, data)
        .then((response) => {
          if (!response) throw new Error("No Response");
          if(response?.data?.result === "ok"){
            return dispatch(switchUserTypeSuccess(data.type))
          } else {
            return dispatch(switchUserTypeFailed(getErrors("Something went wrong. Please try later")));            
          }
        })
        .catch((err) => dispatch(switchUserTypeFailed(getErrors(err))));
    } else {
      dispatch(
        switchUserTypeFailed(getErrors("Something went wrong. Please try later"))
      );
    }
  };
};

// Delete Account
export const deleteAccountStart = () => {
  return {
    type: actionTypes.DELETE_ACCOUNT_START,
  };
};

export const deleteAccountSuccess = () => {
  return {
    type: actionTypes.DELETE_ACCOUNT_SUCCESS,
  };
};

export const deleteAccountFailed = (error: any) => {
  return {
    type: actionTypes.DELETE_ACCOUNT_FAIL,
    error,
  };
};

export const deleteAccount = () => {
  return async (dispatch: any) => {
    dispatch(deleteAccountStart());

    if (localStorage.getItem("m-market-user-token")) {
      return axios
        .post(`/user/profile/delete`)
        .then((response) => {
          if (!response) throw new Error("No Response");
          if(response?.status === 200){
            dispatch(deleteAccountSuccess());
            
            localStorage.removeItem("m-market-user-token");
          } else {
            dispatch(deleteAccountFailed(getErrors("Something went wrong. Please try later")));         
          }
        })
        .catch((err) => dispatch(deleteAccountFailed(getErrors(err))));
    } else {
      dispatch(
        deleteAccountFailed(getErrors("Something went wrong. Please try later"))
      );
    }
  };
};

// Toggle push notifications
export const togglePushNotificationsStart = () => {
  return {
    type: actionTypes.TOGGLE_PUSH_NOTIFICATIONS_START,
  };
};

export const togglePushNotificationsSuccess = () => {
  return {
    type: actionTypes.TOGGLE_PUSH_NOTIFICATIONS_SUCCESS,
  };
};

export const togglePushNotificationsFailed = (error: any) => {
  return {
    type: actionTypes.TOGGLE_PUSH_NOTIFICATIONS_FAIL,
    error,
  };
};

export const togglePushNotifications = (enablePush: boolean) => {
  return async (dispatch: any) => {
    dispatch(togglePushNotificationsStart());

    return axios.post(enablePush ? `/user/profile/push/enable` : `/user/profile/push/disable`)
    .then((response) => {
      if(!response) throw new Error ("No Response");

      return dispatch(togglePushNotificationsSuccess())
    })
    .catch(err => dispatch(updateProfileFailed(getErrors(err))))
  };
};

/* Get other users profile Image */
const getOtherUsersProfileImageStart = (msisdn: string) => {
  return {
    type: actionTypes.GET_OTHER_USERS_PROFILE_IMAGE_START,
    data: {msisdn},
  };
};

const getOtherUsersProfileImageSuccess = (msisdn: string, data: any) => {
  return {
    type: actionTypes.GET_OTHER_USERS_PROFILE_IMAGE_SUCCESS,
    data: {data, msisdn},
  };
};

const getOtherUsersProfileImageFailed = (msisdn: string) => {
  return {
    type: actionTypes.GET_OTHER_USERS_PROFILE_IMAGE_FAIL,
    data: {msisdn},
  };
};

export const getOtherUsersProfileImage = (msisdn: string) => {
  if(!msisdn){
    return;
  }

  return (dispatch: any) => {
    dispatch(getOtherUsersProfileImageStart(msisdn));

    return axios
      .get(`/profile/picture/load/${msisdn}`)
      .then((response: any) => {
        if (!response) throw new Error("No Response");
        let data = getResData(response.data);

        if (!data.success) throw new Error(getErrors(data));

        const image = formatBase64Image(data?.data);

        dispatch(getOtherUsersProfileImageSuccess(msisdn, image));
      })
      .catch((err) => dispatch(getOtherUsersProfileImageFailed(msisdn)));
  };
};